import React, { useEffect, useState } from 'react';
import GroupInput from './UTMFields/GroupInput';
import DetailHeaders from './DetailHeaders.js';
import DetailItem from './DetailItem.js';
import DetailActions from './DetailActions.js';
import axios from 'axios';
import { newUTM } from './helpers';

export default function DetailView({ changeView, curBatch }) {
  const [utmBatch, setUTMBatch] = useState({}); // current UTM batch's full meta data
  const [newUTMList, updateUTMList] = useState([]); // UTM codes from batch rendered to view
  const [configs, setConfigs] = useState({}); // fetched configs for select dropdowns
  const [loading, setLoading] = useState(true);

  const isEmpty = (obj) => Object.keys(obj).length === 0;

  const renderUTMList = () =>
    newUTMList.map((item) => {
      return (
        <DetailItem
          key={item.id}
          item={item}
          updateUTMList={updateUTMList}
          newUTMList={newUTMList}
          configs={configs}
        />
      );
    });

  const updateBatch = () => {
    let newState = { ...utmBatch };
    newState.utm_codes = newUTMList;
    setUTMBatch(newState);
  };

  useEffect(() => {
    updateBatch();
    renderUTMList();
  }, [newUTMList]);

  useEffect(() => {
    newUTMList.length > 0 && !isEmpty(configs)
      ? setLoading(false)
      : setLoading(true);
  }, [newUTMList, configs]);

  // Fetch UTMs by Batch ID or create New UTM Batch Post ID then Fetch Fresh Post
  useEffect(() => {
    let { batch_id } = curBatch;
    const fetchUTMData = async (batch_id) => {
      await axios
        .post(' /wp-admin/admin-ajax.php?action=post_get_utm_by_batch', {
          batch_id
        })
        .then(
          ({
            data: {
              data: { utm_batch }
            }
          }) => {
            const utmCodes = utm_batch.utm_codes;
            setUTMBatch(utm_batch);

            utmCodes.length === 0
              ? updateUTMList([newUTM()])
              : updateUTMList(utmCodes);
          }
        );
    };

    const createUTMPost = async () => {
      const url = `/wp-admin/admin-ajax.php?action=post_save_utm_codes`;

      await axios
        .post(url)
        .then((res) => {
          batch_id = res.data.data;
          fetchUTMData(batch_id);
        })
        .catch((err) => console.log(err));
    };

    batch_id === '' ? createUTMPost() : fetchUTMData(batch_id);
  }, [curBatch]);

  // Format and Populate Configs for Select Options
  useEffect(() => {
    const fetchConfigs = async () => {
      const sources = await axios
        .get('/wp-admin/admin-ajax.php?action=get_utm_sources')
        .then((res) => {
          return res.data.data.sources;
        });
      const mediums = await axios
        .get('/wp-admin/admin-ajax.php?action=get_utm_mediums')
        .then((res) => {
          return res.data.data.mediums;
        });
      const campaigns = await axios
        .get('/wp-admin/admin-ajax.php?action=get_utm_campaigns')
        .then((res) => {
          return res.data.data.campaigns;
        });

      let campaignOptions = [];
      for (const [key, value] of Object.entries(campaigns)) {
        const keyName = `${value.name}+${value.utm_campaign_audience.label}+${value.utm_campaign_strategy.label}`;
        const item = { [keyName]: key };
        campaignOptions.push(item);
      }

      // Alpha Sort Array of Single Key Objects
      campaignOptions.sort((a, b) => {
        const firstItem = Object.keys(a).map((key) => key);
        const secondItem = Object.keys(b).map((key) => key);

        if (firstItem > secondItem) {
          return 1;
        }
        if (secondItem > firstItem) {
          return -1;
        }
        return 0;
      });

      campaignOptions.unshift('Please Choose');

      let sourceOptions = [];
      for (const [key, value] of Object.entries(sources)) {
        const item = { [value]: key };
        sourceOptions.push(item);
      }
      sourceOptions.unshift('Please Choose');

      let mediumOptions = [];
      for (const [key, value] of Object.entries(mediums)) {
        const item = { [value]: key };
        mediumOptions.push(item);
      }
      mediumOptions.unshift('Please Choose');

      const selectConfigs = {
        campaign: {
          label: 'campaign',
          options: campaignOptions
        },
        medium: {
          label: 'medium',
          options: mediumOptions
        },
        source: {
          label: 'source',
          options: sourceOptions
        }
      };
      setConfigs(selectConfigs);
    };
    fetchConfigs();
  }, []);

  return (
    <div className="container u--margin-top-35">
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div>
          <GroupInput
            changeView={changeView}
            utmBatch={utmBatch}
            setUTMBatch={setUTMBatch}
          />
          <div className="utm__table">
            <DetailHeaders />
            {renderUTMList()}
          </div>
          <DetailActions
            addUTM={updateUTMList}
            curList={newUTMList}
            utmBatch={utmBatch}
          />
        </div>
      )}
    </div>
  );
}
